window.LibraryCommonHelpers = window.LibraryCommonHelpers || {
    version: "Library.Common.Helpers: 2018.06.14.2",
    test: function () {
        return "2018.06.14.2";
    },
    parseISO8601String: function (dateString) {
        var timebits = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+-])([0-9]{2})([0-9]{2}))?/;
        var m = timebits.exec(dateString);
        var resultDate;
        if (m) {
            var utcdate = Date.UTC(parseInt(m[1]),
                parseInt(m[2]) - 1, // months are zero-offset (!)
                parseInt(m[3]),
                parseInt(m[4]), parseInt(m[5]), // hh:mm
                (m[6] && parseInt(m[6]) || 0),  // optional seconds
                (m[7] && parseFloat(m[7]) * 1000) || 0); // optional fraction
            // utcdate is milliseconds since the epoch
            if (m[9] && m[10]) {
                var offsetMinutes = parseInt(m[9]) * 60 + parseInt(m[10]);
                utcdate += (m[8] === '+' ? -1 : +1) * offsetMinutes * 60000;
            }
            resultDate = new Date(utcdate);
        } else {
            resultDate = null;
        }
        return resultDate;
    },
    toMyTimeZoneDate: function (date) {
        var current = new Date(LibraryCommonHelpers.parseISO8601String(date));
        var utcDate = new Date(current.getTime() + current.getTimezoneOffset() * 60000);

        return utcDate;
    }
};